import React from 'react';
import { useSelector } from 'react-redux';
import { ILayout, selectDisplayLayout } from '@/store/slices/layoutSlice';
import { alpha, AppBar, Box, Stack, Toolbar } from "@mui/material";
import { styled } from "@mui/material/styles";
import LanguageSelector from "@/components/language-selector";

const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 78;

const RootStyle = styled(AppBar)(() => ({
    boxShadow: 'none',
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
    backgroundColor: alpha('#266188', 0.85),
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
    minHeight: APPBAR_MOBILE,
    [theme.breakpoints.up('lg')]: {
        minHeight: APPBAR_DESKTOP,
        padding: theme.spacing(0, 2)
    }
}));

const HeaderMinimal = (): any => {
    const layout: ILayout = useSelector(selectDisplayLayout);

    if (!layout.minimal) {
        return null;
    }

    return (
        <>
            <RootStyle>
                <ToolbarStyle>
                    <Box sx={{ flexGrow: 1 }} />
                    <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
                        <LanguageSelector />

                    </Stack>
                </ToolbarStyle>
            </RootStyle>
        </>
    );
};

export default HeaderMinimal;
